import Navbar from "./Components/Navbar";
import DashBoard from "./Pages/Customer/DashBoard";
import { Route, Routes } from "react-router-dom";
import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import Config from "./Config";
import moment from "moment";

import CustomerApplications from "./Pages/Customer/Applications";
import CustomerAssociations from "./Pages/Customer/Associations";

import Login from "./Pages/LoginPage";
import Guidelines from "./Pages/Guidelines";
import AdminDashBoard from "./Pages/Admin/AdminDashBoard";
import Applications from "./Pages/Admin/Applications";
import RegisteredAssociation from "./Pages/RegisteredAssociation";

import CorrectionForm from "./Pages/Forms/CorrectionForm";
import ChangeArticleForm from "./Pages/Forms/ChangeArticleForm";
import ChangeAddressForm from "./Pages/Forms/ChangeAddressForm";
import ChangeNameForm from "./Pages/Forms/ChangeNameForm";
import SubmitDocument from "./Pages/Forms/SubmitDocument";

import OtherServices from "./Pages/OtherServices";
import Reports from "./Pages/Reports";
import RegistrationForm from "./Pages/Forms/RegistrationForm";
import EditRegistrationForm from "./Pages/Forms/EditRegistrationForm";
import EditRegistrationFormNewTry from "./Pages/Forms/EditRegistrationFormNewTry";

import EditChangeOfArticleForm from "./Pages/Forms/EditChangeOfArticleForm";
import EditChangeOfNameForm from "./Pages/Forms/EditChangeOfNameForm";
import EditChangeOfAddressForm from "./Pages/Forms/EditChangeOfAddressForm";
import EditCorrectionForm from "./Pages/Forms/EditCorrectionForm";

import AdminNavbar from "./Components/AdminNavbar";
import AsttRegisterars from "./Pages/Admin/AsttRegisterars";
import DistrictRegistrars from "./Pages/Admin/RegionalRegistrar";
import Users from "./Pages/Admin/Users";
import Finance from "./Pages/Admin/Finance";
import RegAssocReport from "./Pages/Admin/RegAssocReport";
import AssocPaymentReport from "./Pages/Admin/AssocPaymentReport";
import OutstandingPaymentReport from "./Pages/Admin/OutstandingPaymentReport";

import Customers from "./Pages/Admin/Customers";
import Payments from "./Pages/Admin/Payments";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Profile from "./Pages/Profile";
import RegisterarDetails from "./Pages/RegisterarDetails";
import SetCharges from "./Pages/SetCharges";
import SetGames from "./Pages/Admin/Games";

import SignupPage from "./Pages/SignupPage";
import ForgotPasswordPage from "./Pages/ForgotPassword";
import { useIdleTimer } from "react-idle-timer";

import "./i18";
import { Remove_User } from "./Redux/actions";
import Region from "./Pages/Admin/Region";
import District from "./Pages/Admin/District";
import Council from "./Pages/Admin/Council";

function App() {
  const user = useSelector((state) => state.UserReducer.user);

  const dispatch = useDispatch();

  const isSessionExpired = () => {
    if (user) {
      const expireAt = user?.expireAt;
      const currentTime = moment().valueOf();
      const isExpired = moment(currentTime).isAfter(expireAt);
      if (isExpired) {
        window.location.href = "/";
        dispatch(Remove_User());
      }
    }
  };

  const { getRemainingTime } = useIdleTimer({
    onIdle: () => isSessionExpired(),
    timeout: 1000 * 60 * Config.idleTime,
  });

  useEffect(() => isSessionExpired(), []);

  const UserType =
    user?.userType == 1
      ? "ADMIN"
      : user?.userType == 2
      ? "REGISTRAR"
      : user?.userType == 3
      ? "ASSREGISTRAR"
      : user?.userType == 4
      ? "FINANCE"
      : user?.userType == 7
      ? "REGIONAL REGISTRAR"
      : "USER";
  //console.log(user);
  if (!user)
    return (
      <>
        <ToastContainer
          position="top-center"
          autoClose={10000}
          hideProgressBar={true}
          newestOnTop={true}
          closeOnClick
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover={false}
        />
        <Routes>
          <Route path="/register" element={<SignupPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />

          <Route path="*" index element={<Login />} />
        </Routes>
      </>
    );

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={10000}
        hideProgressBar={true}
        newestOnTop={true}
        closeOnClick
        pauseOnFocusLoss={false}
        draggable
        pauseOnHover={false}
      />

      {/* {isAdmin ? <AdminNavbar /> : <Navbar />} */}

      <Routes>
        <Route path="/login" element={<Login />} />

        {/* USER_ASSIREGISTRAR */}
        {user?.userType == 4 && (
          <>
            <Route path="/dashboard" element={<AdminDashBoard />} />
            <Route path="/" element={<AdminDashBoard />} />
            <Route path="/applications" element={<Applications />} />
            <Route
              path="/registered-assocs"
              element={<RegisteredAssociation />}
            />
            <Route path="/profile" element={<Profile />} />
            <Route path="/other-services" element={<OtherServices />} />
            <Route path="/registerar" element={<RegisterarDetails />} />
          </>
        )}

        {/* USER_REG_REGISTRAR */}
        {user?.userType == 7 && (
          <>
            <Route path="/dashboard" element={<AdminDashBoard />} />
            <Route path="/" element={<AdminDashBoard />} />
            <Route path="/applications" element={<Applications />} />
            <Route
              path="/registered-assocs"
              element={<RegisteredAssociation />}
            />
            <Route path="/profile" element={<Profile />} />
            <Route path="/other-services" element={<OtherServices />} />
            <Route path="/registerar" element={<RegisterarDetails />} />
          </>
        )}

        {/* Finance */}
        {user?.userType == 2 && (
          <>
            <Route path="/dashboard" element={<AdminDashBoard />} />
            <Route path="/" element={<AdminDashBoard />} />
            {/* <Route
              path="/applications"
              element={<Applications />}
            />
             <Route
              path="/registered-assocs"
              element={<RegisteredAssociation />}
            /> */}
            <Route path="/admin/customers" element={<Customers />} />

            <Route path="/profile" element={<Profile />} />
            <Route path="/registerar" element={<RegisterarDetails />} />
            <Route path="/payments/:days?" element={<Payments />} />
            <Route path="/setcharges" element={<SetCharges />} />
          </>
        )}

        {/* USER_REGISTRAR */}
        {user?.userType == 3 && (
          <>
            <Route path="/dashboard" element={<AdminDashBoard />} />
            <Route path="/" element={<AdminDashBoard />} />
            <Route path="/applications" element={<Applications />} />
            <Route
              path="/registered-assocs"
              element={<RegisteredAssociation />}
            />
            <Route path="/admin/customers" element={<Customers />} />

            <Route path="/profile" element={<Profile />} />
            <Route path="/other-services" element={<OtherServices />} />
            <Route path="/registerar" element={<RegisterarDetails />} />
            {/* reports */}
            <Route path="/report/associations" element={<RegAssocReport />} />
            <Route path="/report/payments" element={<AssocPaymentReport />} />
            <Route
              path="/report/outstandings"
              element={<OutstandingPaymentReport />}
            />
            <Route path="/typeofgames" element={<SetGames />} />
          </>
        )}

        {(user?.userType == 1 || user?.userType == 6) && (
          <>
            <Route path="/" element={<AdminDashBoard />} />
            <Route path="/dashboard" element={<AdminDashBoard />} />
            <Route path="/admin/asttregistrars" element={<AsttRegisterars />} />
            <Route path="/admin/registrars" element={<DistrictRegistrars />} />
            <Route path="/admin/users" element={<Users />} />
            <Route path="/admin/finance" element={<Finance />} />

            <Route path="/admin/customers" element={<Customers />} />

            {/* <Route path="/edit-regapp/:id" element={<EditRegistrationForm />} /> */}
            <Route
              path="/edit-nameform/:id"
              element={<EditChangeOfNameForm />}
            />
            <Route
              path="/edit-constitutionform/:id"
              element={<EditCorrectionForm />}
            />
            <Route
              path="/edit-articleform/:id"
              element={<EditChangeOfArticleForm />}
            />
            <Route
              path="/edit-addressform/:id"
              element={<EditChangeOfAddressForm />}
            />

            {/* reports */}
            <Route path="/report/associations" element={<RegAssocReport />} />
            <Route path="/report/payments" element={<AssocPaymentReport />} />
            <Route
              path="/report/outstandings"
              element={<OutstandingPaymentReport />}
            />

            <Route path="/applications" element={<Applications />} />
            <Route
              path="/registered-assocs"
              element={<RegisteredAssociation />}
            />
            <Route path="/profile" element={<Profile />} />
            <Route path="/registerar" element={<RegisterarDetails />} />
            {/* <Route path="/setcharges" element={<SetCharges />} /> */}
            <Route path="/typeofgames" element={<SetGames />} />
            <Route path="/regions" element={<Region />} />
            <Route path="/districts" element={<District />} />
            <Route path="/councils" element={<Council />} />
            {/* <Route path="/payments" element={<Payments />} /> */}
            <Route path="/other-services" element={<OtherServices />} />
          </>
        )}

        {user?.userType == 5 && (
          <>
            <Route path="/" element={<DashBoard />} />
            <Route path="/guidelines" element={<Guidelines />} />
            <Route path="/dashboard" element={<DashBoard />} />
            <Route path="/correct-const" element={<CorrectionForm />} />
            <Route path="/submit-docs/:id" element={<SubmitDocument />} />
            <Route path="/change-article" element={<ChangeArticleForm />} />
            <Route path="/change-name" element={<ChangeNameForm />} />
            <Route path="/change-address" element={<ChangeAddressForm />} />
            <Route
              path="/edit-regapp/:id"
              element={<EditRegistrationFormNewTry />}
            />
            <Route
              path="/edit-nameform/:id"
              element={<EditChangeOfNameForm />}
            />
            <Route
              path="/edit-constitutionform/:id"
              element={<EditCorrectionForm />}
            />
            <Route
              path="/edit-articleform/:id"
              element={<EditChangeOfArticleForm />}
            />
            <Route
              path="/edit-addressform/:id"
              element={<EditChangeOfAddressForm />}
            />
            <Route path="/registration" index element={<RegistrationForm />} />
            {/* <Route path="/reports" element={<Reports />} /> */}
            <Route path="/my-applications" element={<CustomerApplications />} />
            <Route path="/my-association" element={<CustomerAssociations />} />

            <Route path="/profile" element={<Profile />} />
            <Route path="/registerar" element={<RegisterarDetails />} />
          </>
        )}

        {/* {user?.userType == 1 ? (
          <>
            <Route path="/" element={<AdminDashBoard />} />
            <Route path="/dashboard" element={<AdminDashBoard />} />
            <Route path="/admin/asttregistrars" element={<AsttRegisterars />} />
            <Route path="/admin/registrars" element={<DistrictRegistrars />} />
            <Route path="/admin/users" element={<Users />} />
            <Route path="/admin/finance" element={<Finance />} />

            <Route path="/admin/customers" element={<Customers />} />

            <Route path="/edit-nameform/:id" element={<EditChangeOfNameForm />} />
            <Route path="/edit-constitutionform/:id" element={<EditCorrectionForm />} />
            <Route path="/edit-articleform/:id" element={<EditChangeOfArticleForm />} />
            <Route path="/edit-addressform/:id" element={<EditChangeOfAddressForm />} />

            <Route path="/report/associations" element={<RegAssocReport />} />
            <Route path="/report/payments" element={<AssocPaymentReport />} />
            <Route path="/report/outstandings" element={<OutstandingPaymentReport />} />

            <Route
              path="/applications"
              element={<Applications />}
            />
            <Route
              path="/registered-assocs"
              element={<RegisteredAssociation />}
            />
            <Route path="/profile" element={<Profile />} />
            <Route path="/registerar" element={<RegisterarDetails />} />
            <Route path="/typeofgames" element={<SetGames />} />
            <Route path="/other-services" element={<OtherServices />} />
          </>
        ) : (
          <>
            <Route path="/" element={<DashBoard />} />
            <Route path="/guidelines" element={<Guidelines />} />
            <Route path="/dashboard" element={<DashBoard />} />
            <Route path="/correct-const" element={<CorrectionForm />} />
            <Route path="/submit-docs/:id" element={<SubmitDocument />} />
            <Route path="/change-article" element={<ChangeArticleForm />} />
            <Route path="/change-name" element={<ChangeNameForm />} />
            <Route path="/change-address" element={<ChangeAddressForm />} />
            <Route path="/edit-regapp/:id" element={<EditRegistrationFormNewTry />} />    
            <Route path="/edit-nameform/:id" element={<EditChangeOfNameForm />} />
            <Route path="/edit-constitutionform/:id" element={<EditCorrectionForm />} />
            <Route path="/edit-articleform/:id" element={<EditChangeOfArticleForm />} />
            <Route path="/edit-addressform/:id" element={<EditChangeOfAddressForm />} />
            <Route path="/registration" index element={<RegistrationForm />} />
            <Route path="/my-applications" element={<CustomerApplications />} />  
            <Route path="/my-association" element={<CustomerAssociations />} />           
         
            <Route path="/profile" element={<Profile />} />
            <Route path="/registerar" element={<RegisterarDetails />} />

          </>
        )} */}
      </Routes>

      {/* <Footer /> */}
    </>
  );
}

export default App;
